/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { arrayOf, string, shape, oneOf, func } from 'prop-types'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Checkbox from '@groovehq/internal-design-system/lib/components/Checkbox/Checkbox'

import { selectMailboxes } from 'selectors/mailboxes_base'

import { styles } from './MailboxSelection.styles'
import { mailboxTypes } from './MailboxSelection.data'

const { Menu, Button } = Dropdown

const menu = data => (
  <Menu>
    {data.map(({ title, key }) => (
      <Menu.Item key={key} itemKey={key}>
        {title}
      </Menu.Item>
    ))}
  </Menu>
)

const selectTitle = (all, key) => {
  const selected = all.find(item => item.key === key) || {
    title: '',
  }
  return selected.title
}

const MailboxSelection = ({
  className,
  dropdownBtnStyles,
  checkboxListStyles,
  selectedIds,
  type,
  onMailboxListChange,
  onMailboxTypeChange,
  dropdownBtnSize,
}) => {
  const mailboxes = useSelector(selectMailboxes)

  const selectedMailboxTypeTitle = useMemo(
    () => selectTitle(mailboxTypes, type),
    [type]
  )

  const mailboxList = useMemo(
    () => {
      return mailboxes.map(mailbox => {
        return {
          id: mailbox.gid,
          name: mailbox.name,
          checked: selectedIds.indexOf(mailbox.gid) > -1,
        }
      })
    },
    [mailboxes, selectedIds]
  )

  // Handle mailboxes selection
  const handleCheckboxChange = useCallback(
    (e, id) => {
      const list = mailboxList.map(item => {
        if (item.id === id) {
          return {
            ...item,
            checked: e.target.checked,
          }
        }
        return item
      })
      const newSelectedIds = list
        .filter(item => item.checked)
        .map(item => item.id)
      onMailboxListChange(newSelectedIds)
    },
    [mailboxList, onMailboxListChange]
  )

  return (
    <div className={className}>
      <div css={styles.dropdownContainer}>
        <Dropdown overlay={menu(mailboxTypes)} onSelect={onMailboxTypeChange}>
          <Button
            css={[styles.dropdownBtn, dropdownBtnStyles]}
            size={dropdownBtnSize}
          >
            {selectedMailboxTypeTitle}
          </Button>
        </Dropdown>
      </div>
      {type !== 'all' && (
        <div css={[styles.checkboxList, checkboxListStyles]}>
          {mailboxList.map(item => (
            <Checkbox
              key={item.id}
              id={item.id}
              checked={item.checked}
              onChange={e => handleCheckboxChange(e, item.id)}
            >
              {item.name}
            </Checkbox>
          ))}
        </div>
      )}
    </div>
  )
}

MailboxSelection.propTypes = {
  className: string,
  dropdownBtnStyles: shape({
    name: string,
    styles: string,
  }),
  checkboxListStyles: shape({
    name: string,
    styles: string,
  }),
  selectedIds: arrayOf(string),
  type: oneOf(['all', 'some']),
  onMailboxListChange: func,
  onMailboxTypeChange: func,
  dropdownBtnSize: oneOf(['big', 'small']),
}

MailboxSelection.defaultProps = {
  className: undefined,
  dropdownBtnStyles: undefined,
  checkboxListStyles: undefined,
  selectedIds: [],
  type: mailboxTypes[0].key,
  onMailboxListChange() {},
  onMailboxTypeChange() {},
  dropdownBtnSize: 'big',
}

export default MailboxSelection
